module.exports = {
  ...require('./featImageCollection_PHB'),
}
